import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar.tsx";
import Footer from "../Footer/Footer.tsx";
import BannerCarousel from "../common-component/BannerCarousel.tsx";
import Gallery from "../Gallery/Gallery.tsx";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AboutUs from "../About Us/AboutUs.tsx";
import TableView from "../Table View/TableView.tsx";
import OurProjects from "../OurProjects/OurProjects.tsx";
import { Gallery1, Project1, Project2, Project3 } from "../../Assets.tsx";

gsap.registerPlugin(ScrollTrigger);

const HomePage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useGSAP(() => {
    if (!isMobile) {
      gsap.from(".gsapAboutText", {
        opacity: 0,
        duration: 2,
        x: -500,
        scrollTrigger: {
          trigger: ".gsapAboutText",
          scroller: "body",
          markers: false,
          start: "top 50%",
        },
      });
    }
  });
  useGSAP(() => {
    if (!isMobile) {
      gsap.from(".gsapVishwasImg", {
        opacity: 0,
        duration: 2,
        x: 500,
        scrollTrigger: {
          trigger: ".gsapVishwasImg",
          scroller: "body",
          markers: false,
          start: "top 50%",
        },
      });
    }
  });

  useGSAP(() => {
    if (!isMobile) {
      gsap.from(".gsapAboutText2", {
        opacity: 0,
        duration: 2,
        x: -500,
        scrollTrigger: {
          trigger: ".gsapAboutText2",
          scroller: "body",
          markers: false,
          start: "top 50%",
        },
      });
    }
  });
  useGSAP(() => {
    if (!isMobile) {
      gsap.from(".gsapVishwasImg2", {
        opacity: 0,
        duration: 2,
        x: 500,
        scrollTrigger: {
          trigger: ".gsapVishwasImg2",
          scroller: "body",
          markers: false,
          start: "top 50%",
        },
      });
    }
  });

  const ourHistory = [
    {
      image:Gallery1,
      name: "Shirwal",
      contact: "Contact Us",
    },
    {
      image:
      Project2, 
      name: "Narhe",
      contact: "Contact Us",
    },
    {
      image:
      Project3,
      name: "Kirkatwadi",
      contact: "Contact Us",
    },
    {
      image:
      Project1, 
      name: "Wagholi",
      contact: "Contact Us",
    },
  ];


  return (
    <div>
      <Navbar />

      <div style={{ marginTop: "50px" }}>
        <BannerCarousel />
        {/* <TableView/> */}
        <AboutUs />
        <OurProjects members={ourHistory} />
        <Gallery />
      </div>

      <Footer />
    </div>
  );
};

export default HomePage;
